<template>
  <div class="flex flex-col w-full lg:w-5/6 mx-auto mt-32 h-auto">
    <div v-if="!insertedPayment" class="flex flex-col bg-white bg-opacity-90
      min-h-screen p-2 md:p-10">
      <h1 class="text-xl text-grey-academy-300 flex justify-center border-b-2
      border-grey-academy-150 mx-auto p-2 mb-20 mt-6 w-full">
        {{$t('payments.title')}}
      </h1>
      <div class="flex flex-col w-full font-sans-serif mx-auto lg:w-2/3 mb-20"
      v-if="student.default_payment_method">
        {{$t('payments.default')}}
        <default-payment-method class="mt-10" />
        <div class="flex justify-between mt-5">
          <button class="rounded bg-background-academy w-11/12 md:w-1/4 p-2 mt-5 uppercase
            font-semibold text-white hover:text-background-academy transform text-sm
            hover:scale-105 hover:bg-white border border-background-academy"
            @click="notDefault">
            {{$t('payments.change')}}
          </button>
          <button class="rounded bg-background-academy w-11/12 md:w-1/4 p-2 mt-5 ml-2 uppercase
            hover:bg-white hover:text-background-academy transform text-sm hover:scale-105
            font-semibold text-white border border-background-academy"
            @click="insertedPayment = true" v-if="useDefault">
            {{$t('payments.next')}}
          </button>
        </div>
      </div>
      <div v-if="!student.default_payment_method || !useDefault"
        class="font-sans-serif w-full lg:w-2/3 mx-auto">
          {{$t('payments.choose')}}
        <payment-methods class="mt-5" v-model="defaultPaymentMethod"
          @stripe-changed="stripePaymentMethodId = $event" />
        <div class="flex justify-center mt-10 mb-20" v-if="showSaveButton">
          <modal-button @click="savePaymentMethod"
          :buttonPlaceholder="$t('payments.save')"
          buttonClass="uppercase" :is-loading="isLoading" />
        </div>
      </div>

    </div>
    <div v-else>
      <lesson-summary :lesson="pendingLesson"
        class="bg-white w-full h-full bg-opacity-90 pt-20"/>
      <div class="flex flex-col text-center items-center bg-white h-screen bg-opacity-90">
        <button class="rounded bg-background-academy w-1/2 p-3 mb-5 mt-20 uppercase font-semibold
          border border-background-academy
          hover:bg-white hover:text-background-academy transform hover:scale-105 text-white"
          @click="savePaymentAuthorization" :class="isLoading ? 'loader' : ''">
          {{$t('payments.auth')}}
        </button>
        <span>
          {{$t('payments.title2')}}
        </span>
        <!--<span class="mt-5 text-sm w-2/3">
          {{$t('payments.title3')}}
        </span>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { getLessonByBookingId } from '@/services/LessonService';
import dayjs from 'dayjs';
import ModalButton from '../components/graphics/ModalButton.vue';
import DefaultPaymentMethod from '../components/payment/DefaultPaymentMethod.vue';
import PaymentMethods from '../components/payment/PaymentMethods.vue';
import LessonSummary from '../components/payment/LessonSummary.vue';

export default {
  components: {
    PaymentMethods,
    DefaultPaymentMethod,
    LessonSummary,
    ModalButton,
  },

  data() {
    return {
      defaultPaymentMethod: 'card',
      stripePaymentMethodId: null,

      useDefault: true,

      insertedPayment: false,

      pendingLesson: {},

      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      student: 'auth/student',
    }),

    lessonIsOutOfCancellationDeadline() {
      if (!this.pendingLesson.slot) {
        return null;
      }
      return dayjs.tz()
        .isBetween(dayjs.tz(this.pendingLesson.slot.start_date).subtract(this.pendingLesson.teacher.cancellation_deadline, 'h'),
          dayjs.tz(this.pendingLesson.slot.start_date));
    },

    showSaveButton() {
      if (this.defaultPaymentMethod === 'paypal') {
        return true;
      }
      if (this.defaultPaymentMethod === 'card' && this.stripePaymentMethodId) {
        return true;
      }
      return false;
    },
  },

  created() {
    this.getLesson();
  },

  mounted() {
    this.defaultPaymentMethod = this.student.default_payment_method ? this.student.default_payment_method : 'card';
    if (this.student && !this.student.default_payment_method) {
      this.useDefault = false;
    }
  },

  methods: {
    savePaymentMethod() {
      this.isLoading = true;
      axios.post(`/api/students/${this.student.id}/update-payment-method`,
        { type: this.defaultPaymentMethod, stripe_id: this.stripePaymentMethodId }).then(() => {
        this.insertedPayment = true;
        this.isLoading = false;
        window.scroll(0, 0 - 50);
      }).catch((error) => {
        this.isLoading = false;
        this.checkSessionErrorNotification(error);
      });
    },

    savePaymentAuthorization() {
      this.isLoading = true;
      axios.put(`/api/lessons/${this.$route.query.booking}/update-payment-method?pay_now=${this.lessonIsOutOfCancellationDeadline}`)
        .then(({ data }) => {
          if (this.defaultPaymentMethod === 'paypal') {
            this.loadPaypal(data);
            return;
          }
          this.createNotification('success', this.$t('lesson.success'));
          this.$router.push('/student-dashboard/calendar');
        }).catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },

    loadPaypal(path) {
      window.location.href = path;
    },

    notDefault() {
      this.useDefault = false;
    },

    getLesson() {
      getLessonByBookingId(this.$route.query.booking).then(({ data }) => {
        this.pendingLesson = data;
      });
    },
  },

};
</script>
